import { render, staticRenderFns } from "./FeedbackResult.vue?vue&type=template&id=351e9db3&scoped=true"
import script from "./FeedbackResult.vue?vue&type=script&lang=ts"
export * from "./FeedbackResult.vue?vue&type=script&lang=ts"
import style0 from "./FeedbackResult.vue?vue&type=style&index=0&id=351e9db3&prod&lang=scss"
import style1 from "./FeedbackResult.vue?vue&type=style&index=1&id=351e9db3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "351e9db3",
  null
  
)

export default component.exports